export default function AttachStatementgDialogController(
  $rootScope,
  $scope,
  $q,
  $filter,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  ecatDataService,
  docDataService
) {
  const vm = this;

  vm.canExpand = vm.status !== 'No Folder Added';
  vm.isDocumentsExpanded = true;
  vm.isReportsExpanded = true;
  vm.itemsLoaded = false;
  vm.handleExpandFolder = _handleExpandFolder;
  vm.handleCloseDialog = _handleCloseDialog;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();

    $q.all([
      _refreshFolder(),
    ]).then(() => {
      vm.itemsLoaded = true;
      dfdActivate.resolve();
      loaderService.showViewLoader = false;
    });

    return dfdActivate.promise;
  }

  function _handleExpandFolder() {
    vm.isDocumentsExpanded = !vm.isDocumentsExpanded;

    if (vm.isDocumentsExpanded) {
      _refreshFolder();
    }
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.attachDocumentDialog);
  }

  function _refreshFolder() {
    const dfdRefresh = $q.defer();

    docDataService.getChildItemList(vm.serviceId, vm.folder.documentId).then((response) => {
      vm.folder.childDocuments = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 0 });
      vm.folder.childFolders = $filter('filter')(response.data.ChildDocuments, { documentTypeId: 1 });

      $q.all([
        _updateChildDocuments(),
        _updateChildFolders(),
      ]).then(() => {
        dfdRefresh.resolve();
      });
    });

    return dfdRefresh.promise;
  }

  function _loadReportInstances() {
    const dfdRefresh = $q.defer();

    docDataService.getCustomerReportInstances().then((response) => {
      vm.reportFolders = response.data;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _updateChildDocuments() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childDocuments.length > 0) {
      ecatDataService.getCRIStatementDocumentsByFolder(vm.assessmentId, vm.folder.documentId).then((response) => {
        const assignedDocs = response.data.result;
        if (assignedDocs.length > 0) {
          assignedDocs.forEach((assignedDoc) => {
            vm.folder.childDocuments.forEach((childDoc) => {
              if (childDoc.documentId === assignedDoc.documentId
                && assignedDoc.CRIStatementId === vm.criStatementId) {
                childDoc.CRIStatementDocumentId = assignedDoc.CRIStatementDocumentId;
                childDoc.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }

  function _updateChildFolders() {
    const dfdUpdate = $q.defer();
    if (vm.folder.childFolders.length > 0) {
      ecatDataService.getCRIStatementFoldersByFolder(vm.assessmentId, vm.folder.documentId).then((response) => {
        const assignedFolders = response.data.result;
        if (assignedFolders.length > 0) {
          assignedFolders.forEach((assignedFolder) => {
            vm.folder.childFolders.forEach((childFolder) => {
              if (childFolder.documentId === assignedFolder.folderId && assignedFolder.CRIStatementId === vm.criStatementId) {
                childFolder.CRIStatementFolderId = assignedFolder.CRIStatementFolderId;
                childFolder.attached = true;
              }
            });
          });
        }
        dfdUpdate.resolve();
      });
    } else {
      dfdUpdate.resolve();
    }
    return dfdUpdate.promise;
  }
}

AttachStatementgDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'ecatDataService',
  'docDataService'
];
